import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';

import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CRow,
  CFormLabel,
  CFormSelect
} from '@coreui/react'
import { useParams, useNavigate } from 'react-router-dom'
import { IoMdArrowRoundBack } from "react-icons/io";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoCodescan } from "react-icons/go";
import axios from 'axios';
import { validateEntityName } from '../../../../helpers/validation';
import jwt_decode from 'jwt-decode';
const OpenTicket = () => {

  const navigate = useNavigate()

  const [title, setTitle] = useState("")
  const [category, setCategory] = useState("User Activity")
  const [priority, setPriority] = useState("CRITICAL")
  const [note, setNote] = useState("")
  const [description, setDescription] = useState("")
  const [assignedTo, setAssignedTo] = useState('')  
  const [theStatus, setTheStatus] = useState('');
  const [attachments, setAttachments] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
 const [userRole, setUserRole] = useState(null);


  const [errors, setErrors] = useState({
    title: '',
    description: '',
    note: '',
    assignedTo: '',
    attachments: ''
  });
 

  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const toaster = useRef();
  
  const [selectedFile, setSelectedFile] = useState(null);
    
  const onFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    handleFileChange(e); // if you're passing this prop from parent to handle logic
  };

  const encodeScriptContent = (content) => {
    return content.replace(/<script|<\/script|javascript:|on\w+=/gi, match => {
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    });
  };

  function isExceeding100MB(file){
    const fileSizeInBytes = file.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    return fileSizeInMB > 100;
  }

  useEffect(() => {    
    fetchUsers();   
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('ASIToken');
    const response = await axios.get('/api/v1/organizations/users/all/active', {
      headers: { Authorization: `Bearer ${token}` },
    });
    setUsers(response.data.users);
    if (response.data.users.length > 0) {
      setAssignedTo(response.data.users[0]._id)
    } else {
      setAssignedTo('');
    }
    setLoading(false);
  };

  const [user, setUser] = useState({});
  
  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = () => {
    // setUser(JSON.parse(sessionStorage.getItem('ASIUser')));
    const roleToken = sessionStorage.getItem('accessLevel');
       const decodedToken = jwt_decode(roleToken);
       const userRole = decodedToken.role;
      //  console.log("usssRole",userRole)
        setUserRole(userRole);
  }

  const validateForm = () => {
    let isValid = true;
    let newErrors = {
      title: '',
      description: '',
      note: '',
      assignedTo: '',
      attachments: ''
    };

    if (!validateEntityName(title)) {
      newErrors.title = 'Invalid title. Only letters, numbers, spaces, underscores, dots, #, @ and hyphens are allowed (max 100 characters).';
      isValid = false;
    }

    if (description.length > 10000) {
      newErrors.description = 'Description must not exceed 10,000 characters.';
      isValid = false;
    }

    if (note.length > 10000) {
      newErrors.note = 'Note must not exceed 10,000 characters.';
      isValid = false;
    }

    if (!assignedTo) {
      newErrors.assignedTo = 'Please assign the ticket to a user.';
      isValid = false;
    }

    for (let i = 0; i < attachments.length; i++) {
      if (isExceeding100MB(attachments[i])) {
        newErrors.attachments = 'One or more files exceed the 100MB limit.';
        isValid = false;
        break;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const addTicket = () => {
    if (validateForm()) {
      setLoading(true)      

      const bearerToken = sessionStorage.getItem('ASIToken');

      const formData = new FormData();
      formData.append('title', title);
      formData.append('assignedTo', assignedTo);
      formData.append('description', encodeScriptContent(description));
      formData.append('status', 'Open');
      formData.append('category', category);
      formData.append('priority', priority);
      formData.append('note', encodeScriptContent(note));

      for (let i = 0; i < attachments.length; i++) {
        formData.append('ticketAttachments', attachments[i]);
      }

      const headers = new Headers();
      headers.append('Authorization', `Bearer ${bearerToken}`);
      
      fetch(`${global.backendUrl}/api/v1/organizations/tickets`, {
        method: 'POST',
        headers: headers,
        body: formData
    })    
      .then(response => response.json())
      .then(data => {
        if(data.hasOwnProperty('error')){
           setErrors(prevErrors => ({ ...prevErrors, general: data.error }));
           setLoading(false);
        }
        else if(data.hasOwnProperty('err')){
          setLoading(false);
          setErrors(prevErrors => ({ ...prevErrors, general: "Something went wrong. Please try again" }));
        } else {
           setSubmissionSuccess(true);
           setLoading(false);
           toast('Ticket opened', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          });
           navigate('/tickets')
        }
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
        setErrors(prevErrors => ({ ...prevErrors, general: "An error occurred. Please try again." }));
      });
    }   
  }
 /*
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    setAttachments(selectedFiles);
  };*/

  const handleFileChange = (event) => {
    
    const selectedFiles = Array.from(event.target.files);
    const allowedExtensions = ['.png', '.jpeg', '.jpg', '.doc', '.docx', '.gif', '.pdf', '.txt', '.ppt', '.xls', '.xlsx', '.zip', '.csv'];
    
    const invalidFiles = selectedFiles.filter(file => {
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      return !allowedExtensions.includes(fileExtension);
    });
  
    if (invalidFiles.length > 0) {
      event.target.value = ''; // Clear the file input
      setErrors(prevErrors => ({ 
        ...prevErrors, 
        attachments: 'Invalid file type. Please upload only allowed file types.' 
      }));
      return;
    }
  
    setAttachments(selectedFiles);
  };

  

  const goBack = (e) => {
    e.preventDefault();
    navigate('/tickets')
  }

  if (loading) {
    return (
      <div className="loading-spinner" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '5px solid #f3f3f3',
          borderTop: '5px solid #e50202',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{ display:'flex', overflow: "scroll", position: 'relative', overflowY: 'hidden', overflowX: 'hidden', }}>
      <div style={{ width: '60%' }}>
        <div>
          <div style={{ marginBottom: '0rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <h4>Open a ticket</h4>
            <CButton
                onClick={goBack}
                style={{
                  width: 200,
                  marginBottom: '2%',
                  marginRight:20,
                  borderWidth: 0,
                  fontSize: 13,
                  borderColor: '#fff',
                  borderWidth: 1,
                  color: '#fff',
                  background: 'transparent'
                }}
                color="primary"
                className="px-3"
              >
                <IoMdArrowRoundBack size={25} style={{ color: '#fff', marginRight:10 }} />
                Back to Tickets
              </CButton>
          </div>

          <div style={{ width: '100%', backgroundColor: '#252B3B', padding: 15 }}>
            <CFormLabel htmlFor="formFileSm" style={{ marginTop: 30, color:'white'  }}>Ticket Title<span style={{color:'red'}}>*</span></CFormLabel>
            <CInputGroup className="" style={{ flexDirection: 'column' }}>
              <CFormInput
                placeholder="Ticket Title"
                autoComplete="title"
                className="white-input"
                onChange={(e) => setTitle(e.target.value)}
                style={{ width: '100%' }}
                maxLength={100}
              />
              {errors.title && <div style={{ color: 'red', marginTop: '5px' }}>{errors.title}</div>}
            </CInputGroup>

            <CFormLabel htmlFor="formFileSm" style={{ marginTop: 30, color:'white'  }}>Ticket Category</CFormLabel>
            <CInputGroup className="" style={{ flexDirection: 'column' }}>
              <CFormSelect
                id="scanType"
                className="white-input"
                onChange={(e) => setCategory(e.target.value)}
                style={{ width: '100%' }}
              >
                <option value="User Activity">User Activity</option>
                <option value="Support">Support</option>
                <option value="Network">Network</option>
                <option value="Vulnerability Management">Vulnerability Management</option>
                <option value="Endpoint">Endpoint</option>
                <option value="Threat Management">Threat Management</option>
                <option value="Compliance">Compliance</option>
                <option value="Phishing">Phishing</option>
                <option value="VPN">VPN</option>
                <option value="Suspicious activity">Suspicious activity</option>
              </CFormSelect>
            </CInputGroup>

            <CFormLabel htmlFor="formFileSm" style={{ marginTop: 30, color:'white'  }}>Priority</CFormLabel>
            <CInputGroup className="" style={{ flexDirection: 'column' }}>
              <CFormSelect
                id="scanType"
                className="white-input"
                onChange={(e) => setPriority(e.target.value)}
                style={{ width: '100%' }}
              >
                <option value="CRITICAL">Critical</option>
                <option value="HIGH">High</option>
                <option value="MEDIUM">Medium</option>
                <option value="LOW">Low</option>
              </CFormSelect>
            </CInputGroup>

            <CFormLabel htmlFor="formTextarea" style={{ marginTop: 30, color: 'white' }}>Description</CFormLabel>
            <CInputGroup className="" style={{ flexDirection: 'column' }}>
              <textarea
                id="formTextarea"
                placeholder="Description"
                autoComplete="description"
                className="form-control white-input"
                onChange={(e) => setDescription(e.target.value)}
                style={{ width: '100%', resize: 'vertical', minHeight: '100px' }}
                maxLength={10000}
              />
              {errors.description && <div style={{ color: 'red', marginTop: '5px' }}>{errors.description}</div>}
              <div style={{ color: 'white', marginTop: '5px' }}>{description.length}/10000 characters</div>
            </CInputGroup>

            {(userRole == "Administrator" || userRole == "Application Manager") && (
              <>
                <CFormLabel htmlFor="formFileSm" style={{ marginTop: 30, color: 'white' }}>Assigned To</CFormLabel>
                <CInputGroup className="" style={{ flexDirection: 'column' }}>
                  <CFormSelect
                    id="assignedTo"
                    className="white-input"
                    onChange={(e) => setAssignedTo(e.target.value)}
                    value={assignedTo}
                    style={{ width: '100%' }}
                  >
                    {users.map(user => (
                      <option key={user._id} value={user._id}>
                        {user.firstName} {user.lastName}  ({user.email})
                      </option>
                    ))}
                  </CFormSelect>
                  {errors.assignedTo && <div style={{ color: 'red', marginTop: '5px' }}>{errors.assignedTo}</div>}
                </CInputGroup>
              </>
            )}
          
            <CFormLabel htmlFor="formFileSm" style={{ marginTop: 30, color:'white' }}>Add file(s)</CFormLabel><br/>
            <span>Allowed types: .png, .jpeg, .jpg, .doc, .docx, .gif, .pdf, .txt, .ppt, .xls, .xlsx, .zip, .csv</span><br/>
            {/* <CInputGroup className="" style={{ flexDirection: 'column', }}>
              <CFormInput
                placeholder="Upload file(s)"
                autoComplete="username"
                type="file" 
                className="white-input"
                size="sm"
                id="inputFile"
                multiple
                onChange={handleFileChange}
                accept=".png,.jpeg,.jpg,.doc,.docx,.gif,.pdf,.txt,.ppt,.xls,.xlsx,.zip"
                style={{ width: '100%' }}
              />
              {errors.attachments && <div style={{ color: 'red', marginTop: '5px' }}>{errors.attachments}</div>}
            </CInputGroup> */}

             <CInputGroup style={{ flexDirection: 'column', width: '100%' }}>
              <label htmlFor="inputFile" style={{ 
                padding: '20px', 
                border: '2px dashed #ccc', 
                borderRadius: '10px',
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: '#f9f9f9',
                fontSize: '16px'
              }}>
                {selectedFile ? selectedFile.name : "Click here to upload a file"}
                <CFormInput
                  placeholder="Upload file(s)"
                  autoComplete="username"
                  type="file"
                  id="inputFile"
                  onChange={onFileChange}
                  accept=".png,.jpeg,.jpg,.doc,.docx,.gif,.pdf,.txt,.ppt,.xls,.xlsx,.zip"
                  style={{ display: 'none' }}
                />
              </label>
              {errors.file && <div style={{ color: 'red', marginTop: '5px' }}>{errors.file}</div>}
            </CInputGroup>

            <CFormLabel htmlFor="formTextarea" style={{ marginTop: 30, color: 'white' }}>Note</CFormLabel>
            <CInputGroup className="" style={{ flexDirection: 'column' }}>
              <textarea
                id="formTextarea"
                placeholder="Note"
                autoComplete="note"
                className="form-control white-input"
                onChange={(e) => setNote(e.target.value)}
                style={{ width: '100%', resize: 'vertical', minHeight: '100px' }}
                maxLength={10000}
              />
              {errors.note && <div style={{ color: 'red', marginTop: '5px' }}>{errors.note}</div>}
              <div style={{ color: 'white', marginTop: '5px' }}>{note.length}/10000 characters</div>
            </CInputGroup>

            {errors.general && <div style={{ color: 'red', marginTop: '15px' }}>{errors.general}</div>}

            <CButton
              style={{
                width: '100%',
                marginTop: '3%',
                marginBottom: '2%',
                borderWidth: 0,
                fontSize: 13,
                background: '#e50202'
              }}
              color="primary"
              className="px-3"
              onClick={addTicket}
              disabled={loading}
            >              
              {loading ?
                <CircularProgress color="primary" size={24} style={{ marginTop: 10, color: '#fff' }} />
                :
                'Submit Ticket'
              }</CButton>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      )
    }
    
    export default OpenTicket